import { getBootstrapIconUrl, BootstrapIcon } from '../Global/icons'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const listIcon = getBootstrapIconUrl(BootstrapIcon.List)
const crossIcon = getBootstrapIconUrl(BootstrapIcon.X)

const t = document.createElement('template')
t.innerHTML = `
<!-- Hamburger (mobile only) -->
<wa-button id="mobile-menu-toggle" class="ham-btn utility-icon-button" appearance="plain" aria-expanded="false" aria-label="Toggle mobile menu">
  <wa-icon src="${listIcon}" class="header-icon" label="Open menu"></wa-icon>
</wa-button>
`

class NavHeaderUtilityHamburger extends HTMLElement {
  constructor() {
    super()
    tryLoadDependencies(document, [WebAwesomeComponent.Button, WebAwesomeComponent.Icon])
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  static get observedAttributes() {
    return ['menu-open']
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('Layout connectedCallback')

    const btn = this.getBtn()
    if (!btn) return

    btn.addEventListener('click', () => {
      this.toggleAttribute('menu-open')
      this.dispatchEvent(new CustomEvent('toggle-hamburger', { bubbles: true, composed: true }))
    })

    btn.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault()
        btn.click()
      }
    })

    this.syncUI()
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    if (name === 'menu-open' && oldValue !== newValue) {
      this.syncUI()
    }
  }

  private getBtn(): HTMLElement | null {
    return this.shadowRoot?.getElementById('mobile-menu-toggle') ?? null
  }

  private syncUI() {
    const btn = this.getBtn()
    if (!btn) return

    const isOpen = this.hasAttribute('menu-open')
    const icon = btn.querySelector('wa-icon')
    if (icon) {
      icon.setAttribute('src', isOpen ? crossIcon : listIcon)
      icon.setAttribute('label', isOpen ? 'Close menu' : 'Open menu')
    }
    btn.setAttribute('aria-expanded', String(isOpen))
  }
}

if (!customElements.get('ts-navheader-utility-hamburger')) {
  customElements.define('ts-navheader-utility-hamburger', NavHeaderUtilityHamburger)
}
export { NavHeaderUtilityHamburger }
